import React, { useState } from "react";
import {
  getExpensesAndIncomesReportByDatetXLS
} from "../../../helpers/fakebackend_helper";

import Flatpickr from 'react-flatpickr';
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useLoader } from "../../../context/LoaderContext";

const ExpenseAndIncomeReport = () => {
  const FlatpickrComponent = Flatpickr as unknown as React.ComponentType<any>;
  const defaultStartDate = moment().startOf("month").toDate();
  const defaultEndDate = moment().endOf("month").toDate();
  const [dateRange, setDateRange] = useState<any[]>([defaultStartDate, defaultEndDate]);
  const { showLoader, hideLoader } = useLoader();



  const handleDownloadLoanPaymentList = async () => {
    showLoader();

    try {
      const params: any = {};
      if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        params.startDate = dateRange[0].toISOString().split('T')[0];
        params.endDate = dateRange[1].toISOString().split('T')[0];
      }
      const response = await getExpensesAndIncomesReportByDatetXLS(params);
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Reporte de ingresos y gastos del ' + moment(dateRange[0]).format('YYYY-MM-DD') + ' al ' + moment(dateRange[1]).format('YYYY-MM-DD') + '.xlsx';
      a.click();
    } catch (error) {
      toast.error("Error downloading loan payment list: " + error, { autoClose: 2000 });
    } finally {
      hideLoader();
    }
  };


  return (
    <div className="card">
      <ToastContainer closeButton={false} limit={1} />

      <div className="card-body">

        <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2 xl:grid-cols-12">

          <div className="xl:col-span-3">
            <FlatpickrComponent
              id="dateRangeFilterInput"
              className="form-input border-slate-200 dark:border-zink-500 ..."
              options={{ dateFormat: "d M, Y", mode: "range" }}
              value={dateRange}
              onChange={(range: Date[]) => {
                if (range.length === 2 && range[0] instanceof Date && range[1] instanceof Date) {
                  setDateRange(range);
                }
              }}
              placeholder="Select date"
            />
          </div>

          <div className="xl:col-span-3">
            <button
              onClick={handleDownloadLoanPaymentList}
              className="flex items-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold rounded-lg shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-300"
            >
              <i className="ri-file-excel-2-line text-lg"></i>
              Descargar Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseAndIncomeReport;
